<template>
  <div id="course-list" class="course-list">
    <div
      v-if="courses.length <= 0"
      style="display:flex;justify-content:center;order:3;width:100%;margin-bottom:100px"
    >
      <no-results
        :text="'There aren’t any available courses on these dates'"
        :icon="'fa-calendar-alt'"
      />
    </div>
    <course-card
      v-for="course in courses"
      v-else
      :id="course.id"
      :key="course.id"
      :unit-code="course.unit_code"
      :suburb="course.suburb"
      :fee="course.fee"
      :timezone="timezone"
      :sessions="course.sessions"
      :state="course.state"
      :skip-payment="skipPayment"
      :unit-constituents-info="course.unit_constituents_info"
      :places-remaining="course.places_remaining"
      :delivery-mode="course.delivery_mode"
      :is-iframe="isIframe"
      :is-full-width="isFullWidth"
      :timezone-abbreviation="course.timezone_abbreviation"
      :unit-descriptor="course.unit_descriptor"
      :unit-subheading="course.unit_subheading"
      :start-datetime="course.humanized_start_time"
    />
  </div>
</template>
<script>
  import CourseCard from './course_card';
  import NoResults from '../tdesk/no_results_placeholder';

  export default {
    components: {CourseCard, NoResults},
    props: {
      skipPayment: {
        type: Boolean,
      },
      courses: {
        type: Array,
        required: true,
      },
      isIframe: {
        type: Boolean,
        required: false,
      },
      isFullWidth: {
        type: Boolean,
        required: false,
      },
      timezone: {
        type: String,
        required: true,
      },
    },
  };
</script>
